import { render, staticRenderFns } from "./table-mentee.vue?vue&type=template&id=a692bbda"
import script from "./table-mentee.vue?vue&type=script&lang=js"
export * from "./table-mentee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports